{
  "it": {
    "milestone": {
      "actions": {
        "activate": "Attiva",
        "active": "Attiva",
        "create": "Crea tappa",
        "deactivate": "Disattiva",
        "delete": "Elimina",
        "delete_milestones": "Elimina tappa | Elimina {count} tappe",
        "new": "Tappa"
      },
      "activate": {
        "confirm": "Attiva",
        "intro": "Attivando questa tappa:",
        "past_warning": "Tornare a una tappa precedente non annullerà quanto già accaduto. Ciò che è stato condiviso con i clienti non verrà revocato automaticamente.",
        "title": "Attiva tappa",
        "verb_default": "Avvia",
        "verb_share": "Condividi"
      },
      "attach": {
        "add": "Aggiungi",
        "add_kind": "Aggiungi {kind}",
        "assigned_tag": "Assegnato",
        "back": "Indietro",
        "counts": "{available} disponibili · {assigned} già assegnati",
        "description_decision": "Decisioni che il cliente deve prendere",
        "description_survey": "Questionari per raccogliere informazioni",
        "empty": "Nessun elemento disponibile",
        "empty_state_description": "In base al Suo piano può aggiungere {kinds} a questa tappa.",
        "intro": "Scelga il tipo di elemento che desidera collegare a questa tappa.",
        "next": "Avanti",
        "search": "Cerca",
        "select_intro": "Selezioni {kind} da aggiungere.",
        "subtitle": "Tappa: {name}",
        "success": "Elementi aggiunti",
        "title": "Aggiungi elementi"
      },
      "labels": {
        "add_element": "Aggiungi elemento",
        "add_kind": "Aggiungi {kind}",
        "assign_units": "Assegna unità",
        "assigned_count": "0 assegnati | 1 assegnato | {count} assegnati",
        "assigned_elements": "Elementi assegnati",
        "assigned_empty_description": "Colleghi {kinds} a questa tappa",
        "assigned_empty_title": "Nessun elemento ancora",
        "bulk_assign_title": "Selezioni le unità a cui desidera assegnare la tappa '{milestone_name}'",
        "edit_milestone": "Modifica tappa",
        "empty_state_subtitle": "Le tappe rendono il processo di costruzione più trasparente per gli acquirenti",
        "empty_state_title": "Crea una nuova tappa",
        "finished_on": "Completata il {date}",
        "future_milestones": "Tappe future",
        "kind_decision": "Decisione | Decisioni",
        "kind_survey": "Questionario | Questionari",
        "kind_todo": "Attività | Attività",
        "milestone": "Tappa",
        "milestone_name": "Nome tappa",
        "milestone_unit_count": "0 unità | 1 unità | {count} unità",
        "milestones": "Tappe",
        "new_milestone": "Nuova tappa",
        "no_milestone": "Nessuna tappa assegnata",
        "no_results": "Nessuna tappa trovata",
        "past_milestones": "Tappe passate",
        "please_select": "Selezioni una nuova tappa",
        "position": "Posizione",
        "search_empty_state": "Nessuna tappa creata. Faccia clic qui per iniziare",
        "started_on": "Iniziata il {date}",
        "status_active": "Attiva",
        "status_completed": "Completata",
        "status_planned": "Pianificata",
        "status_planned_subtitle": "Non ancora iniziata",
        "unit_timeline_empty": "Non sono ancora state create tappe per questo progetto.",
        "units": "Unità",
        "units_without_milestone": "1 unità senza tappa | {count} unità senza tappa",
        "warning_delete": "Attenzione: se elimina una tappa assegnata a un'unità, il cliente perderà la visione della tappa in cui si trova la propria unità. Assegni una nuova tappa a queste unità."
      },
      "toasts": {
        "bulk_assigned": "La tappa è stata assegnata con successo alle unità selezionate",
        "create_success": "Tappa creata con successo",
        "deactivate_success": "Tappa disattivata con successo",
        "sup_assigned": "La tappa è stata attivata con successo",
        "update_success": "Le tappe sono state aggiornate con successo"
      },
      "validation": {
        "needName": "Nome obbligatorio",
        "needNamePrimary": "Il nome nella lingua principale ({language}) è obbligatorio"
      }
    }
  }
}
